<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 20px auto 0px 15px"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column type="index" width="80" align="center" label=" "></el-table-column>

      <el-table-column
        prop="Nickname"
        label="用户名"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Phone"
        label="手机号"
        width="200"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="uStatus"
        label="用户类型"
        width="250"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.CustomerType == 1 ? 'success' : 'danger'"        
            disable-transitions
            >{{ scope.row.CustomerTypeName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        align="center"
        sortable
        width="200"
      ></el-table-column>
      <el-table-column
        prop="uStatus"
        label="关联学生"
        align="center"
        width
        sortable
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.MyStudentName != null ? 'success' : 'danger'"
            @click="editClassRole(scope.row.Id)"
            disable-transitions
            >编辑班级权限
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width sortable align="center">
        <template slot-scope="scope">
          <!-- <span class="SpanList"  @click="setResetPawassed(scope.row)" >关联学生</span> -->
           <!-- <span class="SpanList" @click="editClassRole(scope.row.Id)">编辑班级权限</span> -->
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
        <!-- <el-button type="primary" @click="setResetPawassed(scope.row)"
            >重置密码</el-button
          > -->
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="5"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    
    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-tree
        :data="data5"
        show-checkbox
        node-key="value"
        ref="tree"
        default-expand-all
        :expand-on-click-node="true"
        :check-strictly="true"
      >
        <span class="custom-tree-node" slot-scope="{ node }">
          <span>{{ node.label }}</span>
          <span>
            <el-checkbox-group v-model="assignBtns"> </el-checkbox-group>
          </span>
        </span>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="saveteachermap"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetCustomerByPage,
  AddStudentMapCustomerInfo,
  GetPermissionTree,
  DelCustomer,
  SaveTeacherClassMap,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      rowid: 0,
      data5: [],
      assignBtns: [],
      buttonList: [],
      currentRow: null,
      filters: {
        LinkUrl: "",
      },
      users: [],
      statusList: [
        { LinkUrl: "激活", value: true },
        { LinkUrl: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        StudentName: [
          { required: true, message: "学生姓名", trigger: "blur" },
        ],
        StudentCode: [
          { required: true, message: "学生学号", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Tel: "",
        StudentName: "",
        StudentCode:"",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        LinkUrl: [
          { required: true, message: "请输入接口地址", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CateName: "",
        OrderSort: 0,
        Enabled: "",
      },
    };
  },
  methods: {
    saveteachermap() {
        let para = {
        CustomerId: this.rowid,
        ClassIds: this.$refs.tree.getCheckedKeys(),
      };
      SaveTeacherClassMap(para).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
         this.editFormVisible = false;
        this.getModules();
      });
    },
    editClassRole(id) {
      this.rowid = id;
      this.editFormVisible = true;
      let para = {
        Id: id,
      };
      GetPermissionTree(para).then((res) => {
        this.data5 = JSON.parse(JSON.stringify(res.data.response.children));
        this.$refs.tree.setCheckedKeys(res.data.response.assignbtns);
        this.assignBtns = res.data.response.assignBtns;
      });
    },
    setteacher(item) {
      this.$confirm("确认修改用户类型吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let CustomerType = 1;
          if (item.CustomerType == 1) {
            CustomerType = 2;
          }
          let para = {
            Id: item.Id,
            CustomerType: CustomerType,
          };
          AddStudentMapCustomerInfo(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    //获取用户列表
    getModules() {
      let para = {
        page: this.page,
        Name:this.filters.name,
        CustomerType:2
      };
      this.listLoading = true;

      //NProgress.start();
      GetCustomerByPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel(id) {
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要删除的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: id };
          DelCustomer(para).then((res) => {
            // if (util.isEmt.format(res)) {
            //   this.listLoading = false;
            //   return;
            // }
            this.listLoading = false;
            //NProgress.done();
            if (res.data) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message:"删除失败",
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(row) {
      console.log(row)
      if (row.MyStudentName != null) {
         this.$notify.info({
          title: '消息',
          message: '已绑定过学生',
           type: 'warning'
        });
        return;
      }
      this.$confirm("确认关联学生?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.editFormVisible = true;
      this.editForm.Tel = row.Phone;
        })
        .catch(() => {});
      // let row = rows;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要编辑的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      // this.editFormVisible = true;
      // this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.$message({message:"功能暂未开放"});
      return;
      // this.addFormVisible = true;
      // this.addForm = {
      //   CreateBy: "",
      //   LinkUrl: "",
      //   Name: "",
      //   Enabled: "true",
      // };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");

            AddStudentMapCustomerInfo(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getModules();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            CateInfoAdd(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getModules();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
    this.getModules();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
